(() => {
  function init(root) {
    if (root.dataset.next22Ready) return;
    root.dataset.next22Ready = "true";
    const views = [...root.querySelectorAll("[data-next22-view]")];
    const tabs = [...root.querySelectorAll("[data-next22-view-button]")];
    tabs.forEach((button, selected) => button.addEventListener("click", () => {
      views.forEach((image, index) => { image.hidden = index !== selected; });
      tabs.forEach((item, index) => item.setAttribute("aria-pressed", String(index === selected)));
    }));
    const videoOpen = root.querySelector('[data-next22-video-open]');
    const videoDialog = root.querySelector('[data-next22-video-dialog]');
    const videoContainer = videoDialog?.querySelector('[data-next22-video-container]');
    const videoClose = videoDialog?.querySelector('[data-next22-video-close]');
    if (videoOpen && videoDialog && videoContainer && videoClose) {
      videoOpen.addEventListener('click', () => {
        let url;
        try { url = new URL(videoOpen.dataset.videoUrl); } catch { return; }
        if (!['youtube.com', 'www.youtube.com', 'youtu.be'].includes(url.hostname)) return;
        const id = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.searchParams.get('v');
        if (!/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        frame.title = 'Product video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        videoContainer.replaceChildren(frame);
        videoDialog.showModal();
        videoClose.focus();
      });
      videoClose.addEventListener('click', () => videoDialog.close());
      videoDialog.addEventListener('close', () => {
        videoContainer.replaceChildren();
        videoOpen.focus({preventScroll:true});
      });
    }
    const board = root.querySelector(".life-board");
    const onImage = root.querySelector("[data-next22-on]");
    const offImage = root.querySelector("[data-next22-off]");
    const lights = [...root.querySelectorAll("[data-next22-light]")];
    const onAlt = onImage.alt;
    const offAlt = offImage.dataset.alt;
    lights.forEach(button => button.addEventListener("click", () => {
      const lit = button.dataset.next22Light === "on";
      board.dataset.lit = String(lit);
      onImage.alt = lit ? onAlt : "";
      offImage.alt = lit ? "" : offAlt;
      onImage.setAttribute("aria-hidden", String(!lit));
      offImage.setAttribute("aria-hidden", String(lit));
      lights.forEach(item => item.setAttribute("aria-pressed", String((item.dataset.next22Light === "on") === lit)));
      root.querySelector("[data-next22-light-status]").textContent = lit ? "Lights on" : "Lights off";
    }));
    const included = root.querySelector("[data-gob-included-inline]");
    const variantData = included?.querySelector("[data-gob-included-variants]");
    if (variantData) {
      const variants = JSON.parse(variantData.textContent);
      const productRoot = document.querySelector("[data-gob-daylight]");
      const select = productRoot?.querySelector("[data-product-select]");
      const update = id => {
        const variant = variants.find(item => String(item.id) === String(id));
        const tab = variant?.tab || 0;
        included.querySelectorAll("[data-gob-included-tab]").forEach(panel => { panel.hidden = Number(panel.dataset.gobIncludedTab) !== tab; });
        const unknown = included.querySelector("[data-gob-included-unknown]");
        if (unknown) unknown.hidden = Boolean(tab);
        const version = included.querySelector("[data-gob-included-version]");
        if (version) version.textContent = variant?.title || "";
        included.querySelectorAll("[data-gob-included-version-id]").forEach(item => item.setAttribute("aria-pressed", String(item.dataset.gobIncludedVersionId === String(id))));
      };
      update(select?.value || variants[0]?.id);
      included.querySelectorAll("[data-gob-included-version-id]").forEach(button => button.addEventListener("click", () => {
        const variant = variants.find(item => String(item.id) === button.dataset.gobIncludedVersionId);
        if (!variant) return;
        update(variant.id);
        const radio = [...(productRoot?.querySelectorAll('.d-v input[type="radio"]') || [])].find(item => item.value === variant.title);
        if (radio && !radio.disabled) radio.click();
      }));
      document.addEventListener("variant:change", event => {
        const variant = event.detail?.variant;
        if (variant && variants.some(item => String(item.id) === String(variant.id))) update(variant.id);
      });
    }
  }
  const start = () => document.querySelectorAll("[data-gob-next22-story]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
  document.addEventListener("shopify:section:load", start);
})();
